import { idColumn } from '@/shared/grids/columns/idColumn';
import { textColumn } from '@/shared/grids/columns/textColumn';
import { ClientType } from '@/shared/types/enum';
import { GridSettings } from '@/shared/types/grid';
import { enumOptions } from '@/shared/utils/enum';

import { TemplateView } from '@prisma/client';

export const templateGrid: GridSettings<TemplateView> = {
  defaultSort: {
    name: 'asc',
  },
  columns: [
    idColumn(),
    textColumn({
      header: 'Template',
      field: 'name',
      width: 300,
      allowFiltering: false,
    }),
    textColumn({
      header: 'Service',
      field: 'serviceId',
      width: 200,
      allowFiltering: false,
      extra: {
        displayField: 'serviceName',
        sortField: 'serviceName',
        filter: {
          lookup: 'Service',
        },
      },
    }),
    textColumn({
      header: 'Client Type',
      field: 'clientType',
      allowFiltering: false,
      extra: {
        displayField: 'clientTypeName',
        sortField: 'clientTypeName',
        filter: {
          options: enumOptions(ClientType),
        },
      },
    }),
    textColumn({
      header: 'Subject',
      field: 'subject',
      width: 1000,
      allowFiltering: false,
    }),
  ],
};
